import { CloseRounded } from "@mui/icons-material";
import {
  Button,
  createTheme,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import { useDialog } from "../contexts/DialogContext";

const theme = createTheme({
  palette: {
    primary: {
      main: "#05204C",
    },
    secondary: {
      main: "#00b4d8",
    },
  },
});

export type Question = (question: string, description?: string, options?: {
  confirmText?: string;
  cancelText?: string;
}) => Promise<boolean | null | undefined>;

export default function useQuestion() {
  const dialog = useDialog();
  return (
    question: string,
    description?: string,
    options?: {
      confirmText?: string;
      cancelText?: string;
    },
  ) =>
    dialog<boolean | null>(
      (resolve) => (
        <ThemeProvider theme={theme}>
          <Tooltip placement="right" title="סגירה">
            <IconButton
              onClick={() => {
                resolve(null);
              }}
              sx={{
                position: "absolute",
                top: "2.5%",
                right: "0.5%",
                zIndex: 2,
              }}
            >
              <CloseRounded fontSize="small" />
            </IconButton>
          </Tooltip>
          <DialogTitle color="primary">{question}</DialogTitle>
          <DialogContent>{description}</DialogContent>
          <DialogActions sx={{ gap: "1vw" }}>
            <Button
              sx={{ textTransform: "none" }}
              variant="outlined"
              onClick={() => resolve(false)}
            >
              {options?.cancelText ?? "ביטול"}
            </Button>
            <Button
              sx={{ textTransform: "none" }}
              variant="contained"
              onClick={() => resolve(true)}
            >
              {options?.confirmText ?? "אישור"}
            </Button>
          </DialogActions>
        </ThemeProvider>
      ),
      null,
    );
}
